module.exports = __webpack_public_path__ + "img/prepare-lesson-up-disabled.a963e5e0.svg";